'use client';

import {
  DrawerTrigger,
  DrawerTitle,
  DrawerContent,
  Drawer,
  DrawerClose,
  DrawerHeader,
  DrawerDescription,
} from '@/components/ui/drawer';
import { trackEvent } from '@/lib/amplitude';
import { AmplitudeEvents } from '@/lib/amplitude/events';
import useNavigation from '@/lib/hooks/useNavigation';
import { IBranchDetails } from '@/types/stores';
import { ArrowDownNarrowWide, ArrowUpDown, ArrowUpNarrowWide, X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

type TProps = {
  details: IBranchDetails;
};

const SortByPrice = ({ details }: TProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const params = useSearchParams();
  const price = params.get('price');

  const { removeQueryString, createQueryString } = useNavigation();
  const t = useTranslations('stores');

  // styling the price button
  const isPriceLow = price === 'low' ? 'border-primary text-primary font-bold  border-2' : '';
  const isPriceHeigh = price === 'heigh' ? 'border-primary text-primary font-bold border-2' : '';

  return (
    <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerTrigger
        className=""
        onClick={() => {
          setIsDrawerOpen(true);
          trackEvent(AmplitudeEvents.Filter_Clicked, {
            storeID: details.store.id,
            storeName: details.store.englishName,
            branchID: details.id,
            branchName: details.englishName,
          });
        }}
        aria-label="Show Price Filter"
      >
        <DrawerTitle className="border-secondary text-primary flex h-11 w-11 items-center justify-center rounded-2xl border-2 bg-white">
          <ArrowUpDown size={20} />
        </DrawerTitle>
      </DrawerTrigger>

      <DrawerContent className="min-h-[40vh] bg-white px-5">
        <DrawerTitle className="mb-4 flex items-center justify-between py-4 text-xl">
          <DrawerHeader>{t('sort-by')}</DrawerHeader>
          <DrawerClose onClick={() => setIsDrawerOpen(false)}>
            <X />
          </DrawerClose>
        </DrawerTitle>
        <DrawerDescription className="flex w-full flex-col">
          <button
            onClick={() => {
              if (price === 'low') {
                removeQueryString('price');
              } else {
                createQueryString({ price: 'low' });
              }
              setIsDrawerOpen(false);
            }}
          >
            <div
              className={`${isPriceLow} mb-2 flex w-full items-center gap-2 rounded-xl border p-4`}
            >
              <ArrowDownNarrowWide />
              {t('low-price')}
            </div>
          </button>
          <button
            onClick={() => {
              if (price === 'heigh') {
                removeQueryString('price');
              } else {
                createQueryString({ price: 'heigh' });
              }
              setIsDrawerOpen(false);
            }}
          >
            <div
              className={` ${isPriceHeigh} mb-2 flex w-full items-center gap-2 rounded-xl border p-4`}
            >
              <ArrowUpNarrowWide />
              {t('heigh-price')}
            </div>
          </button>
        </DrawerDescription>
      </DrawerContent>
    </Drawer>
  );
};

export default SortByPrice;
